import type {CanvasChatMessage} from './canvas-types';
import {isActiveRun,type RecoverableRun} from './canvas-run-recovery';
const VERIFIED_FOR_MS=15_000;
/** Poll receipts are client runtime evidence, not persisted conversation facts. */
export function withoutProgressPollEvidence<T extends object>(message:T):Omit<T,'conceptRunVerifiedAt'|'workflowRunPoll'>{
 const {conceptRunVerifiedAt,workflowRunPoll,...rest}=message as T&{conceptRunVerifiedAt?:unknown;workflowRunPoll?:unknown};
 return rest;
}
/** Only a successful poll of this card's exact workflow can verify a detached run. */
export function recordWorkflowPoll(message:CanvasChatMessage,run:RecoverableRun,now=Date.now()):CanvasChatMessage{
 if(message.playbookProgress?.workflowRunId!==run.id)return message;
 return {...message,workflowRunPoll:isActiveRun(run)&&!message.playbookProgress.isDone?{runId:run.id,verifiedAt:now}:undefined};
}
/** A successful poll verifies this message, not another task's typing session. */
export function recordConceptPoll(message:CanvasChatMessage,setStatus:string|undefined,now=Date.now()):CanvasChatMessage{
 return {...message,conceptRunVerifiedAt:message.conceptsRun?.status==='generating' && (setStatus===undefined || setStatus==='generating') ? now : undefined};
}
export function isCanvasMessageLive(message:CanvasChatMessage,localWorking:boolean,now=Date.now()):boolean{
 const poll=message.workflowRunPoll;
 if(poll&&message.playbookProgress?.workflowRunId===poll.runId&&!message.playbookProgress.isDone&&now>=poll.verifiedAt&&now-poll.verifiedAt<VERIFIED_FOR_MS)return true;
 if(message.conceptsRun?.autoBuild && localWorking && message.isStreaming && message.agentTaskGroups?.some(group=>group.status==='active' && group.steps.some(step=>step.toolName==='run_angles_to_campaign')))return true;
 if(message.conceptsRun && message.conceptsRun.status!=='generating' && !(message.playbookProgress && !message.playbookProgress.isDone))return false;
 if(localWorking && message.isStreaming)return true;
 const verified=message.conceptRunVerifiedAt;
 return message.conceptsRun?.status==='generating' && typeof verified==='number' && now>=verified && now-verified<VERIFIED_FOR_MS;
}
